import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { useConfig } from 'hook/config.hook';

const AccountMixLeyendRow = props => {
  const {
    tooltipContentCopy,
    labelLeft,
    labelRight,
    dontDottedLine,
    labelClass,
    onClick,
  } = props;

  const dottedLine = classnames('dottedLine flexGrow', {
    poof: dontDottedLine,
  });
  const { config } = useConfig();
  const tooltipContent = tooltipContentCopy
    ? tooltipContentCopy
    : config?.summaryTooltips?.ACCOUNT_MIX?.howIsThisCalculatedTooltip;

  return (
    <FlexContainer className={'justify-between items-align-center width100'}>
      <FlexContainer className="items-align-center">
        <CSTooltip
          removeMarginsMobile
          isInline={true}
          placement={'bottom'}
          tooltipContent={tooltipContent}
          tooltipName="How is this calculated"
        >
          <Label type="caption margR8" className={labelClass} tabIndex="-1">
            {labelLeft}
          </Label>
        </CSTooltip>
      </FlexContainer>
      <FlexContainer className={dottedLine} />
      <FlexContainer>
        <Label
          type="caption margL8"
          className={labelClass || 'bold'}
          onClick={onClick}
        >
          {labelRight}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AccountMixLeyendRow;
